
const func = () => {}

export function request({ 
	method, 
	headers = {}, 
	url, 
	body, 
	onComplete = func, 
	onUploadProgress = func, 
	onUpload = func, 
	onUploadError = func, 
	onError = func 
}) {

	if (!url) return onComplete(null)
	const req = new XMLHttpRequest()
	const upload = req.upload
	
	upload.addEventListener('load', event => onUpload(event))
	upload.addEventListener('error', event => onUploadError(event))
	upload.addEventListener('progress', event => onUploadProgress(event.loaded / event.total * 100 || 100))

	req.addEventListener('readystatechange', event => {
		if (req.readyState !== 4) return
		if (req.status == 200) return onComplete(JSON.parse(req.responseText))
		if (req.status != 200) return onError(JSON.parse(req.responseText))
	})
	req.open(method, url, true)
	Object.keys(headers).forEach(key => req.setRequestHeader(key, headers[key]))
	req.send(body)
}